import { Material } from "../Material/Material.type";
import { Project, Store } from "../Project/Project.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type GoodReturn = {
  id: number;
  date: string;
  good_return_number: number;
  from_id: number;
  to_id: number;
  from_project_return: Project;
  to_project_return: Project;
  from_store_return: Store;
  to_store_return: Store;
  from_project_id: number;
  to_store_id: number;
  from_store_id: number;
  to_project_id: number;
  mode: string;
  in_date: string;
  out_date: string;
  user_id: number;
  authorized_by: string;
  good_return_items: GoodReturnItem[];
  good_return_prepared_by?: User;
  is_done: boolean;
  good_return_statuses: GoodReturnStatus[];
  key?: number;
  // Backend fields
  gr_from: Store;
  gr_to: Store;
  gr_prepared_by?: User;
  gr_approved_by?: User;
  gr_checked_by?: User;
  gr_received_by?: User;
  project_id: number;
  store_id: number;
};

export type GoodReturnStatus = {
  good_return_id: number;
  type: "View" | "Check" | "Approve";
  status: number;
  assigned_by: number;
  user_id: number;
  id: number;
};

export type GoodReturnItem = {
  good_out_id: number;
  material: Material;
  unit: string;
  material_id: number;
  quantity: number;
  id?: number;
};

export type GoodReturnStateTypes = {
  fetchAll: ApiCallState<GoodReturn[]>;
  fetchOne: ApiCallState<GoodReturn | null>;
};

export const GoodReturnActionTypes = {
  FETCH_ALL_GOOD_RETURN: "FETCH_ALL_GOOD_RETURN",
  FETCH_ALL_GOOD_RETURN_RESET: "FETCH_ALL_GOOD_RETURN_RESET",
  FETCH_ALL_GOOD_RETURN_FAILURE: "FETCH_ALL_GOOD_RETURN_FAILURE",
  FETCH_ALL_GOOD_RETURN_SUCCESS: "FETCH_ALL_GOOD_RETURN_SUCCESS",

  FETCH_ONE_GOOD_RETURN: "FETCH_ONE_GOOD_RETURN",
  FETCH_ONE_GOOD_RETURN_RESET: "FETCH_ONE_GOOD_RETURN_RESET",
  FETCH_ONE_GOOD_RETURN_FAILURE: "FETCH_ONE_GOOD_RETURN_FAILURE",
  FETCH_ONE_GOOD_RETURN_SUCCESS: "FETCH_ONE_GOOD_RETURN_SUCCESS",
};

